export default "__VITE_ASSET__DXZHuZib__"